import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer.model';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  
  dataSource = new MatTableDataSource<Customer>();
  displayedColumns: string[] = ['id', 'name', 'email', 'contactNo', 'actions'];
  isLoading = false;
  error = '';
  searchValue = '';
  
  // Pagination properties
  totalElements = 0;
  pageSize = 20;
  pageIndex = 0;
  pageSizeOptions = [10, 20, 50, 100];

  constructor(
    private customerService: CustomerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCustomers("");
  }

  /**
   * Load customers from service with pagination
   */
  loadCustomers(search: string = ""): void {
    this.isLoading = true;
    this.error = '';
    
    this.customerService.getCustomers(search, this.pageIndex, this.pageSize).subscribe({
      next: (response) => {
        if (response && response.content) {
          this.dataSource.data = response.content;
          this.totalElements = response.totalElements;
        } else {
          const customers = response.data || response || [];
          this.dataSource.data = customers;
          this.totalElements = customers.length;
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading customers:', error);
        this.error = 'Failed to load customers. Please try again.';
        this.isLoading = false;
        this.dataSource.data = [];
        this.totalElements = 0;
      }
    });
  }

  /**
   * Perform server-side search
   */
  onSearch(): void {
    this.pageIndex = 0; // Reset to first page when searching
    this.loadCustomers(this.searchValue.trim());
  }

  /**
   * Clear search filter and reload data
   */
  clearSearch(): void {
    this.searchValue = '';
    this.pageIndex = 0;
    this.loadCustomers("");
  }

  /**
   * Navigate to edit customer page
   * @param customer Customer to edit
   */
  editCustomer(customer: Customer): void {
    if (customer.id || customer.uuid) {
      // Navigate to customer edit page with customer ID or UUID
      this.router.navigate(['/landing/customer-edit', customer.id || customer.uuid]);
    } else {
      console.error('Cannot edit customer: No ID or UUID found');
    }
  }

  /**
   * Handle pagination events
   */
  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadCustomers(this.searchValue.trim());
  }

  /**
   * Refresh the customer list
   */
  refreshList(): void {
    this.pageIndex = 0;
    this.loadCustomers(this.searchValue.trim());
  }

  /**
   * Refresh customer list
   */
  addCustomer(): void {
    this.router.navigate(['/landing/customer-details']);
  }
}
